import { useMemo } from 'react';

import isEmpty from 'lodash/isEmpty';

import {
    getCurrentContentTitle,
    getCurrentContentFeedKeys,
    getCurrentContentCommunityIds,
} from '@lumapps/contents/ducks/selectors';
import { useWatch } from '@lumapps/lumx-forms';
import { useSelector } from '@lumapps/redux/react';
import { isContentInSpaceFeatureEnabled } from '@lumapps/spaces/ducks/selectors';

import { CONTENT_PROPERTIES_NAMES } from '../constants';

export const useContentValidity = () => {
    const isContentInSpaceEnabled = useSelector(isContentInSpaceFeatureEnabled);

    let titleObject;
    let feedKeys;
    let communityIds;
    const legacyTitleObject = useSelector(getCurrentContentTitle);
    const legacyFeedKeys = useSelector(getCurrentContentFeedKeys);
    const legacyCommunityIds = useSelector(getCurrentContentCommunityIds);

    try {
        [titleObject, feedKeys, communityIds] = useWatch({
            name: [
                CONTENT_PROPERTIES_NAMES.TITLE,
                CONTENT_PROPERTIES_NAMES.VISIBLE_BY,
                CONTENT_PROPERTIES_NAMES.VISIBLE_BY_SPACES,
            ],
        });
    } catch (error) {
        titleObject = legacyTitleObject;
        feedKeys = legacyFeedKeys;
        communityIds = legacyCommunityIds;
    }

    const isValid = useMemo(() => {
        if (!titleObject || isEmpty(titleObject)) {
            return false;
        }

        // Visibility is satisfied by at least one group, or — when content-in-space is enabled —
        // at least one space. This mirrors the content editor schema validation.
        const hasGroups = !isEmpty(feedKeys);
        const hasSpaces = isContentInSpaceEnabled && !isEmpty(communityIds);

        if (!hasGroups && !hasSpaces) {
            return false;
        }

        return true;
    }, [feedKeys, communityIds, isContentInSpaceEnabled, titleObject]);

    return isValid;
};
